import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { ILandingFloat, ILandingSection } from "../../../../data/interfaces"
import FloatAnimateContainer from "./FloatAnimateContainer"
import FloatContainer from "./FloatContainer"
import FloatContent from "./FloatContent"
import FloatPositionContainer from "./FloatPositionContainer"

/* Protopia Ecosystem component */
export interface IFloatProps { 
    float: ILandingFloat
    i:number
    section: ILandingSection
    animated?: ANIMATED_STYLE[]
    animated_delay?: ANIMATE_DELAY 
}
const Float = ( props : IFloatProps ): JSX.Element => {
    return <FloatPositionContainer { ...props } > 
        <FloatContainer { ...props } >
            <FloatAnimateContainer { ...props } >
                <FloatContent { ...props } />  
            </FloatAnimateContainer>
        </FloatContainer>                   
    </FloatPositionContainer>
}
export default Float


